import React from "react";

export const AuthRightPanel = ({ bgImage }) => {
    return (
        <div
            className=" md:col-span-6 hidden md:block relative w-full h-full"
            style={{
                backgroundImage: `url(${bgImage})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
            }}
        >
        </div>
    );
};
